import { useContext, useEffect } from "react";

import { isBlank } from "../../lib/presence";
import { RedirectReceiptPageContext } from "./RedirectReceiptPageProvider";

const Redirect = ({ setMode }) => {
  const { paymentIntent } = useContext(RedirectReceiptPageContext);

  useEffect(() => {
    if (isBlank(paymentIntent)) {
      return;
    }

    if (["succeeded", "processing"].includes(paymentIntent.status)) {
      setMode("receipt");
    } else {
      setMode("failure");
    }
  }, [paymentIntent, setMode]);

  return null;
};

export default Redirect;
